import type { SVGProps } from "react"

const ChainSolarSystemIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={278}
    height={131}
    viewBox="0 0 278 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_22_2432"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={-7}
      y={-125}
      width={376}
      height={376}
    >
      <path d="M369 -125H-7V251H369V-125Z" fill="white" />
      <path
        d="M180.402 86.4976C183.163 86.4976 185.402 84.259 185.402 81.4976C185.402 78.7361 183.163 76.4976 180.402 76.4976C177.64 76.4976 175.402 78.7361 175.402 81.4976C175.402 84.259 177.64 86.4976 180.402 86.4976Z"
        fill="black"
      />
      <path
        d="M188.858 49.922C191.62 49.922 193.858 47.6834 193.858 44.922C193.858 42.1606 191.62 39.922 188.858 39.922C186.097 39.922 183.858 42.1606 183.858 44.922C183.858 47.6834 186.097 49.922 188.858 49.922Z"
        fill="black"
      />
      <path
        d="M207.059 54.8667C209.82 54.8667 212.059 52.6281 212.059 49.8667C212.059 47.1053 209.82 44.8667 207.059 44.8667C204.297 44.8667 202.059 47.1053 202.059 49.8667C202.059 52.6281 204.297 54.8667 207.059 54.8667Z"
        fill="black"
      />
      <path
        d="M145.191 72.6565C147.953 72.6565 150.191 70.4179 150.191 67.6565C150.191 64.8951 147.953 62.6565 145.191 62.6565C142.43 62.6565 140.191 64.8951 140.191 67.6565C140.191 70.4179 142.43 72.6565 145.191 72.6565Z"
        fill="black"
      />
      <path
        d="M202.66 53.0012C205.421 53.0012 207.66 50.7626 207.66 48.0012C207.66 45.2398 205.421 43.0012 202.66 43.0012C199.898 43.0012 197.66 45.2398 197.66 48.0012C197.66 50.7626 199.898 53.0012 202.66 53.0012Z"
        fill="black"
      />
      <path
        d="M155.331 54.6763C158.092 54.6763 160.331 52.4377 160.331 49.6763C160.331 46.9148 158.092 44.6763 155.331 44.6763C152.569 44.6763 150.331 46.9148 150.331 49.6763C150.331 52.4377 152.569 54.6763 155.331 54.6763Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_22_2432)">
      <path
        d="M181 81.5C201.435 81.5 218 73.2173 218 63C218 52.7827 201.435 44.5 181 44.5C160.565 44.5 144 52.7827 144 63C144 73.2173 160.565 81.5 181 81.5Z"
        stroke="#676B7E"
        strokeOpacity={0.4}
        strokeDasharray="2 2"
      />
    </g>
    <mask
      id="mask1_22_2432"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={-7}
      y={-125}
      width={376}
      height={376}
    >
      <path d="M369 -125H-7V251H369V-125Z" fill="white" />
      <path
        d="M166.34 112.267C169.102 112.267 171.34 110.028 171.34 107.267C171.34 104.505 169.102 102.267 166.34 102.267C163.579 102.267 161.34 104.505 161.34 107.267C161.34 110.028 163.579 112.267 166.34 112.267Z"
        fill="black"
      />
      <path
        d="M249.217 61.6604C251.978 61.6604 254.217 59.4218 254.217 56.6604C254.217 53.899 251.978 51.6604 249.217 51.6604C246.455 51.6604 244.217 53.899 244.217 56.6604C244.217 59.4218 246.455 61.6604 249.217 61.6604Z"
        fill="black"
      />
      <path
        d="M211.183 42.2178C213.945 42.2178 216.183 39.9792 216.183 37.2178C216.183 34.4563 213.945 32.2178 211.183 32.2178C208.422 32.2178 206.183 34.4563 206.183 37.2178C206.183 39.9792 208.422 42.2178 211.183 42.2178Z"
        fill="black"
      />
      <path
        d="M193.497 112.469C196.258 112.469 198.497 110.23 198.497 107.469C198.497 104.707 196.258 102.469 193.497 102.469C190.735 102.469 188.497 104.707 188.497 107.469C188.497 110.23 190.735 112.469 193.497 112.469Z"
        fill="black"
      />
      <path
        d="M141.197 44.8081C143.959 44.8081 146.197 42.5695 146.197 39.8081C146.197 37.0467 143.959 34.8081 141.197 34.8081C138.436 34.8081 136.197 37.0467 136.197 39.8081C136.197 42.5695 138.436 44.8081 141.197 44.8081Z"
        fill="black"
      />
      <path
        d="M110.264 86.8677C113.025 86.8677 115.264 84.6291 115.264 81.8677C115.264 79.1063 113.025 76.8677 110.264 76.8677C107.503 76.8677 105.264 79.1063 105.264 81.8677C105.264 84.6291 107.503 86.8677 110.264 86.8677Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask1_22_2432)">
      <path
        d="M181 108C221.869 108 255 91.4345 255 71C255 50.5655 221.869 34 181 34C140.131 34 107 50.5655 107 71C107 91.4345 140.131 108 181 108Z"
        stroke="#676B7E"
        strokeOpacity={0.4}
        strokeDasharray="2 2"
      />
    </g>
    <mask
      id="mask2_22_2432"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={-7}
      y={-125}
      width={376}
      height={376}
    >
      <path d="M369 -125H-7V251H369V-125Z" fill="white" />
      <path
        d="M137.04 33.038C139.802 33.038 142.04 30.7994 142.04 28.038C142.04 25.2765 139.802 23.038 137.04 23.038C134.279 23.038 132.04 25.2765 132.04 28.038C132.04 30.7994 134.279 33.038 137.04 33.038Z"
        fill="black"
      />
      <path
        d="M100.196 45.9481C102.958 45.9481 105.196 43.7095 105.196 40.9481C105.196 38.1867 102.958 35.9481 100.196 35.9481C97.435 35.9481 95.1964 38.1867 95.1964 40.9481C95.1964 43.7095 97.435 45.9481 100.196 45.9481Z"
        fill="black"
      />
      <path
        d="M253.577 125.993C256.338 125.993 258.577 123.754 258.577 120.993C258.577 118.231 256.338 115.993 253.577 115.993C250.815 115.993 248.577 118.231 248.577 120.993C248.577 123.754 250.815 125.993 253.577 125.993Z"
        fill="black"
      />
      <path
        d="M76.871 103.223C79.6324 103.223 81.871 100.985 81.871 98.2233C81.871 95.4618 79.6324 93.2233 76.871 93.2233C74.1095 93.2233 71.871 95.4618 71.871 98.2233C71.871 100.985 74.1095 103.223 76.871 103.223Z"
        fill="black"
      />
      <path
        d="M209.791 137.601C212.552 137.601 214.791 135.362 214.791 132.601C214.791 129.839 212.552 127.601 209.791 127.601C207.029 127.601 204.791 129.839 204.791 132.601C204.791 135.362 207.029 137.601 209.791 137.601Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask2_22_2432)">
      <path
        d="M181 134.5C242.304 134.5 292 109.652 292 79C292 48.3482 242.304 23.5 181 23.5C119.696 23.5 70 48.3482 70 79C70 109.652 119.696 134.5 181 134.5Z"
        stroke="#676B7E"
        strokeOpacity={0.4}
        strokeDasharray="2 2"
      />
    </g>
    <mask
      id="mask3_22_2432"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={-7}
      y={-125}
      width={376}
      height={376}
    >
      <path d="M369 -125H-7V251H369V-125Z" fill="white" />
      <path
        d="M68.0421 44.1865C70.8035 44.1865 73.0421 41.9479 73.0421 39.1865C73.0421 36.4251 70.8035 34.1865 68.0421 34.1865C65.2807 34.1865 63.0421 36.4251 63.0421 39.1865C63.0421 41.9479 65.2807 44.1865 68.0421 44.1865Z"
        fill="black"
      />
      <path
        d="M273.198 34.1134C275.96 34.1134 278.198 31.8748 278.198 29.1134C278.198 26.352 275.96 24.1134 273.198 24.1134C270.437 24.1134 268.198 26.352 268.198 29.1134C268.198 31.8748 270.437 34.1134 273.198 34.1134Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask3_22_2432)">
      <path
        d="M181 161C262.738 161 329 127.869 329 87C329 46.1309 262.738 13 181 13C99.2619 13 33 46.1309 33 87C33 127.869 99.2619 161 181 161Z"
        stroke="#676B7E"
        strokeOpacity={0.4}
        strokeDasharray="2 2"
      />
    </g>
    <path
      d="M180.402 83.4976C181.506 83.4976 182.402 82.6021 182.402 81.4976C182.402 80.393 181.506 79.4976 180.402 79.4976C179.297 79.4976 178.402 80.393 178.402 81.4976C178.402 82.6021 179.297 83.4976 180.402 83.4976Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M188.858 46.9221C189.963 46.9221 190.858 46.0267 190.858 44.9221C190.858 43.8175 189.963 42.9221 188.858 42.9221C187.754 42.9221 186.858 43.8175 186.858 44.9221C186.858 46.0267 187.754 46.9221 188.858 46.9221Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M207.059 51.8667C208.163 51.8667 209.059 50.9713 209.059 49.8667C209.059 48.7621 208.163 47.8667 207.059 47.8667C205.954 47.8667 205.059 48.7621 205.059 49.8667C205.059 50.9713 205.954 51.8667 207.059 51.8667Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M145.191 69.6565C146.296 69.6565 147.191 68.7611 147.191 67.6565C147.191 66.5519 146.296 65.6565 145.191 65.6565C144.087 65.6565 143.191 66.5519 143.191 67.6565C143.191 68.7611 144.087 69.6565 145.191 69.6565Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M202.66 50.0012C203.764 50.0012 204.66 49.1058 204.66 48.0012C204.66 46.8967 203.764 46.0012 202.66 46.0012C201.555 46.0012 200.66 46.8967 200.66 48.0012C200.66 49.1058 201.555 50.0012 202.66 50.0012Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M155.331 51.6763C156.435 51.6763 157.331 50.7808 157.331 49.6763C157.331 48.5717 156.435 47.6763 155.331 47.6763C154.226 47.6763 153.331 48.5717 153.331 49.6763C153.331 50.7808 154.226 51.6763 155.331 51.6763Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M166.34 109.267C167.445 109.267 168.34 108.371 168.34 107.267C168.34 106.162 167.445 105.267 166.34 105.267C165.236 105.267 164.34 106.162 164.34 107.267C164.34 108.371 165.236 109.267 166.34 109.267Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M249.217 58.6604C250.321 58.6604 251.217 57.765 251.217 56.6604C251.217 55.5558 250.321 54.6604 249.217 54.6604C248.112 54.6604 247.217 55.5558 247.217 56.6604C247.217 57.765 248.112 58.6604 249.217 58.6604Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M211.183 39.2178C212.288 39.2178 213.183 38.3223 213.183 37.2178C213.183 36.1132 212.288 35.2178 211.183 35.2178C210.079 35.2178 209.183 36.1132 209.183 37.2178C209.183 38.3223 210.079 39.2178 211.183 39.2178Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M193.497 109.469C194.601 109.469 195.497 108.573 195.497 107.469C195.497 106.364 194.601 105.469 193.497 105.469C192.392 105.469 191.497 106.364 191.497 107.469C191.497 108.573 192.392 109.469 193.497 109.469Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M141.197 41.8081C142.302 41.8081 143.197 40.9127 143.197 39.8081C143.197 38.7035 142.302 37.8081 141.197 37.8081C140.093 37.8081 139.197 38.7035 139.197 39.8081C139.197 40.9127 140.093 41.8081 141.197 41.8081Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M110.264 83.8677C111.369 83.8677 112.264 82.9722 112.264 81.8677C112.264 80.7631 111.369 79.8677 110.264 79.8677C109.159 79.8677 108.264 80.7631 108.264 81.8677C108.264 82.9722 109.159 83.8677 110.264 83.8677Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M137.04 30.0378C138.145 30.0378 139.04 29.1424 139.04 28.0378C139.04 26.9333 138.145 26.0378 137.04 26.0378C135.936 26.0378 135.04 26.9333 135.04 28.0378C135.04 29.1424 135.936 30.0378 137.04 30.0378Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M100.196 42.948C101.301 42.948 102.196 42.0526 102.196 40.948C102.196 39.8434 101.301 38.948 100.196 38.948C99.0918 38.948 98.1964 39.8434 98.1964 40.948C98.1964 42.0526 99.0918 42.948 100.196 42.948Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M253.577 122.993C254.681 122.993 255.577 122.097 255.577 120.993C255.577 119.888 254.681 118.993 253.577 118.993C252.472 118.993 251.577 119.888 251.577 120.993C251.577 122.097 252.472 122.993 253.577 122.993Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M76.871 100.223C77.9755 100.223 78.871 99.328 78.871 98.2234C78.871 97.1188 77.9755 96.2234 76.871 96.2234C75.7664 96.2234 74.871 97.1188 74.871 98.2234C74.871 99.328 75.7664 100.223 76.871 100.223Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M209.791 134.601C210.895 134.601 211.791 133.705 211.791 132.601C211.791 131.496 210.895 130.601 209.791 130.601C208.686 130.601 207.791 131.496 207.791 132.601C207.791 133.705 208.686 134.601 209.791 134.601Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M68.0421 41.1865C69.1467 41.1865 70.0421 40.2911 70.0421 39.1865C70.0421 38.082 69.1467 37.1865 68.0421 37.1865C66.9375 37.1865 66.0421 38.082 66.0421 39.1865C66.0421 40.2911 66.9375 41.1865 68.0421 41.1865Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M273.198 31.1133C274.303 31.1133 275.198 30.2179 275.198 29.1133C275.198 28.0087 274.303 27.1133 273.198 27.1133C272.094 27.1133 271.198 28.0087 271.198 29.1133C271.198 30.2179 272.094 31.1133 273.198 31.1133Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
    <path
      d="M181 70C184.866 70 188 66.866 188 63C188 59.134 184.866 56 181 56C177.134 56 174 59.134 174 63C174 66.866 177.134 70 181 70Z"
      stroke="#676B7E"
      strokeOpacity={0.4}
    />
  </svg>
)
export default ChainSolarSystemIllustration
